import selection from "./modules/selection"
import maintenance from "./modules/maintenance"

export default {
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {},
    modules: {
        maintenance,
        selection
    }
}